"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * This hook is like React.useState but applies changes after a certain timeout.
 */
function useStaging(initial, timeout = 1000) {
    const [value, setValue] = (0, react_1.useState)(initial);
    const [staging, setStaging] = (0, react_1.useState)(initial);
    (0, react_1.useEffect)(() => {
        const handle = setTimeout(() => setValue(staging), timeout);
        return () => clearTimeout(handle);
    }, [staging]);
    return [value, staging, setStaging];
}
exports.default = useStaging;
